import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, Tabs, Tab, ButtonGroup, Button } from "react-bootstrap";
import { httpGet } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import {
  NoFeedIcon,
  SocialBlogIcon,
  BlogIcon,
  SocialForumIcon,
} from "../Icons/icons.component";
import { TABS, VERTICALS, APP_CONSTANTS, SOCIAL_SOURCES, SOCIAL_ICONS } from "../../constants/app-constant";
import SocialFeedItem from "./SocialFeedItem";
import SocialFeedsModal from "./SocialFeedsModal";
import Loader from "../Shared/Loader";
import "./style.sass";
import ShareArticle from "../Shared/ShareArticle";
import moment from "moment";
const cilClientList = [
  "CIL",
  "Pralhad Joshi",
  "Central Coalfields Ltd",
  "Eastern Coalfields Ltd",
  "Western Coalfields Ltd",
  "Northern Coalfields Ltd",
  "South Eastern Coalfields Ltd",
  "Mahanadi Coalfields Ltd",
  "Central Mine Planning and Design Institute",
  "Singareni Collieries Company Ltd",
  "Bharat Coking Coal Ltd",
];
const SocialFeeds = () => {
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const { V_SOCIAL, V_BLOG, V_FORUM } = VERTICALS;
  const [apiInProgress, setApiInProgress] = useState(false);
  const [tabKey, setTabKey] = useState(selectedClient.id == '11717'?"feeds":TABS[0].toLowerCase());
  const [vertical, setVertical] = useState(V_SOCIAL);
  const [showModal, setShowModal] = useState(false);
  const [tabData, setTabData] = useState([]);
  const [feedsToShare, setFeedsToshare] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [channelType, setChannelType] = useState(0);

  const selectedEntity =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.selectedEntity
    ) || null;

  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );

  const parentClientId = useSelector((state) => state.entityAndKeyWordsReducer.parentClientId);

  const { socialEntityList } = entityState || [];

  // const clientName = selectedClient.client_name === "CIL";
  const clientName =
    cilClientList.indexOf(selectedClient.client_name) === -1 ? false : true;

  useEffect(() => {
    if (socialEntityList) {
      const entIdList = socialEntityList.map((e) => e && e.id);
      setSelectedTopics(entIdList);
    }
  }, [socialEntityList, entityState]);

  useEffect(() => {
    if (
      selectedClient &&
      selectedClient.id &&
      selectedEntity &&
      selectedEntity.id
    ) {
      getTodaysFeeds();
    }
  }, [selectedClient, selectedEntity, vertical, channelType]);

  const handleSelectedFeeds = (feed) => {
    const selectedElm = feedsToShare.filter((n) => n.id == feed.id);
    if (selectedElm && selectedElm[0]) {
      setFeedsToshare(feedsToShare.filter((n) => n.id != selectedElm[0].id));
    } else {
      setFeedsToshare([...feedsToShare, feed]);
    }
  };

  const renderTabData = () => {
    return (selectedClient.id == '11717'?["Feeds"]:TABS).map((item, index) => {
      const currrentTabData = (tabData[index] && tabData[index]["data"]) || [];
      const allArticleList = currrentTabData.map(
        (e) => `${e.channel_type}/${e.id}?entityName="${e.topic.name}"`
      );
      if (tabData.length > 0) {
        return (
          <Tab
            key={index}
            eventKey={item.toLowerCase()}
            title={selectedClient.id == '11717'?item+`(${tabData[index]["category_count"]})`:`${item === "Competitor" && clientName ? "Subsidiaries" : item
              }(${tabData[index]["category_count"]})`}
          >
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                {tabData[index] &&
                  tabData[index]["data"] &&
                  tabData[index]["data"].length > 0 ? (
                  <>
                    {tabData[index]["data"]
                      .map((item, idx) => (
                        <SocialFeedItem
                          key={item.id}
                          {...item}
                          checked={false}
                          topicType={vertical}
                          onFeedSelect={handleSelectedFeeds}
                          selectedVertical={vertical}
                          clientId={selectedClient.id}
                          feedsToShare={feedsToShare}
                          allArticleList={allArticleList}
                        />
                      ))
                      .slice(0, 2)}
                    {tabData[index]["category_count"] > 2
                      ? renderViewAll()
                      : null}
                  </>
                ) : (
                  <div className="noFilterDataWrap no-feeds">
                    <NoFeedIcon size="sm" />
                    <h6>No Feeds Found</h6>
                  </div>
                )}
              </>
            )}
          </Tab>
        );
      }
    });
  };

  const getClientId = () => {
    const id = selectedClient.id;
    // if (parentEntityId && parentEntityId !== id && !selectedClient.client_name)
    //   id = parentEntityId;
    return id ? id.toString() : "";
  };

  const getTodaysFeeds = () => {
    setApiInProgress(true);
    let url = `${unifiedEnvConfig.SOCIAL_DAILY_FEEDS_LIST
      }?client_id=${getClientId()}&perPage=2&type=${vertical}&topic_name=${selectedClient.client_name
      }`
    if(Number(channelType) !== 0 && selectedClient.id == "11717"){
      url+=`&channel_type[]=${channelType}`
    }  
    httpGet(
      url,
      {},
      true
    )
      .then((response) => {
        setApiInProgress(false);
        const {
          data: { data },
        } = response;
        setTabData(data);
      })
      .catch((e) => {
        if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
          setApiInProgress(true);
        } else {
          setApiInProgress(false);
        }
      });
  };

  const renderViewAll = () => {
    return (
      <div className="view-all-button" onClick={() => setShowModal(true)}>
        View All
      </div>
    );
  };

  const setVerticalValue = (topic) => {
    setVertical((prevState) => parseInt(topic, 10));
  };

  const handleVerticalClick = (verticalValue) => {
    if (verticalValue) {
      setFeedsToshare([]);
      if(selectedClient.id == "11717"){
        setChannelType(verticalValue)
      }
      else{
        setVerticalValue(verticalValue);
        setTabKey(TABS[0].toLowerCase());
      }

      setApiInProgress(false);
    }
  };

  const handleTabClick = (tab) => {
    setFeedsToshare([]);
    setTabKey(tab);
  };

  return (
    <>
      <Card className="cardWrap cls-tf" body>
        <div className="cardTop">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => handleVerticalClick(e.target.value)}
          >
            <Button
              className={Number(channelType) === 0 ? "tagBlue active" : "tagBlue"}
              value={0}
            >
              <SocialBlogIcon />
              Social
            </Button>
            {selectedClient.id == "11717"?Object.keys(SOCIAL_SOURCES).map((sData) => (
              <Button
                className={Number(channelType) === SOCIAL_SOURCES[sData] ? "tagBlue active" : "tagBlue"}
                value={SOCIAL_SOURCES[sData]}
              >
                {SOCIAL_ICONS.find((sIcon) => sIcon.value === SOCIAL_SOURCES[sData])?.icon}
                {sData}
              </Button>
            )):""}
            {/* <Button
              className={vertical === V_BLOG ? "tagViolet active" : "tagViolet"}
              value={V_BLOG}
            >
              <BlogIcon />
              Blogs
            </Button>
            <Button
              className={vertical === V_FORUM ? "tagBrown active" : "tagBrown"}
              value={V_FORUM}
            >
              <SocialForumIcon />
              Forums
            </Button> */}
          </ButtonGroup>
          <ShareArticle
            article={feedsToShare}
            isSocial={vertical === V_SOCIAL}
            isBlogAndForum={vertical == V_BLOG || vertical == V_FORUM}
            onShareSuccess={() => setFeedsToshare([])}
            {...selectedClient.id == "11717"?{fromDate:moment().subtract(1,'day').startOf("day").format("MM/DD/YYYY HH:mm:ss"),
              toDate:moment().endOf("day").format("MM/DD/YYYY HH:mm:ss")}:{}}
          />
        </div>
        {
          <React.Fragment key={tabKey}>
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                <Tabs
                  activeKey={tabKey}
                  transition={false}
                  onSelect={(k) => handleTabClick(k)}
                >
                  {renderTabData()}
                </Tabs>
              </>
            )}
          </React.Fragment>
        }
      </Card>

      {showModal ? (
        <SocialFeedsModal
          show={showModal}
          onCancel={setShowModal}
          clientId={selectedClient.id}
          handleTabClick={handleTabClick}
          handleVerticalClick={handleVerticalClick}
          selectedVertical={vertical}
          selectedTabKey={tabKey}
          tabData={tabData}
          clientName={clientName}
          channelType={channelType}
        />
      ) : null}
    </>
  );
};

export default SocialFeeds;
